module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    staticClass: "viewbox1",
    attrs: {
      "body-padding-bottom": "111px"
    }
  }, [_c('div', {
    staticClass: "body",
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("被保险人是否具有以下任何一种情况？")]), _vm._v(" "), _c('ul', {
    staticClass: "notifies"
  }, _vm._l((_vm.notifies), function(notify, index) {
    return _c('li', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(notify)
      }
    })
  })), _vm._v(" "), (_vm.isAeonlife) ? _c('div', {
    staticClass: "aeonlife-underwriting"
  }, [_c('p', [_vm._v("如果您对某个健康状况不确认，可提供相关资料，我们会向保险公司确认后反馈。详情可咨询客服："), _c('br'), _c('a', {
    attrs: {
      "id": "tel-ask-about",
      "href": "tel:400-661-2992"
    }
  }, [_vm._v("400-661-2992")]), _vm._v("咨询")]), _vm._v(" "), (!_vm.fit) ? _c('p', {
    staticClass: "aeonlife-underwriting__link"
  }, [_c('span', {
    on: {
      "click": _vm.next
    }
  }, [_vm._v("点击申请健康告知确认 >>")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('span', {
    class: {
      active: _vm.fit === false, 'theme-bg-color': _vm.fit === false, 'border-theme-color': _vm.fit === false
    },
    on: {
      "click": _vm.fitfalse
    }
  }, [_vm._v("部分情况有")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.fit === true, 'theme-bg-color': _vm.fit === true, 'border-theme-color': _vm.fit === true
    },
    on: {
      "click": _vm.fittrue
    }
  }, [_vm._v("以上情况全无")])]), _vm._v(" "), _c('div', {
    staticClass: "next theme-bg-color",
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v("下一步")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c6b5358","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notify.vue
// module id = 673
// module chunks = 1